var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":_vm.fHeaderColorBackGround,"height":"107px","clipped-left":_vm.$vuetify.breakpoint.lgAndUp}},[_c('a',{attrs:{"href":_vm.fURLSite,"target":"_blank"}},[_c('v-img',{attrs:{"src":_vm.getImageURL(),"max-height":_vm.fMaxHeight,"max-width":_vm.fMaxWidth}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }